module.exports = __webpack_public_path__ + "d09b3948af72c4ca1e8329ca07dff201.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/furnitures/floor_items/popcorn.png
// module id = 1585
// module chunks = 0